<div class="container">
  <div class="shield-container">
    <img [src]="resources.images.philips"/>
  </div>
  <div class="product-name-container">
    <span>{{productName}}</span>
  </div>
  <div class="common-name-container">
    <span>Radiology Information System</span>
    <span class="common-version">Version {{commonVersion}}</span>
  </div>

  <div class="lot-ref-container">
    <div class="lot-symbol">LOT</div>
    <span class="lot-number">{{commercialVersion}}</span>
    <div class="ref-symbol">REF</div>
    <span class="ref-number">{{productCodeNumber}}</span>
  </div>

  <div class="main-text-container">
    <div class="main-text-container-inner">
      <span [innerHTML]="'Copyright' | cpLabelTranslate:['© ' + buildYear] | async | cpBoldText:'© \\d+ Koninklijke Philips N.V.'"></span>
      <p>
        {{'SoftwareLicensingStatement' | cpMessageTranslate | async}}
      </p>
      <p>
        {{'ReengineeringStatement' | cpMessageTranslate | async}}
      </p>
      <div [ngClass]="{'non-medical': isNonMedicalDevice}">Build: {{internalVersion}}</div>

      <span *ngIf="isNonMedicalDevice">{{'NonDiagnosticStatement' | cpLabelTranslate | async}}</span>
      <p *ngIf="isUnreleasedDevice">
        {{'WarrantyDisclaimer' | cpLabelTranslate:['Philips Radiology Information System', commercialVersion] | async }}
      </p>
    </div>

    <div class="manufacturer-name-address-container">
      <img [src]="resources.images.manufacturerSymbol" />
      <div class="name-address">
        <span>Philips Medical Systems Nederland B.V.</span>
        <span>Veenpluis 6, 5684 PC  Best, The Netherlands</span>
      </div>
    </div>
  </div>
  <div class="about-footer-container">
    <div>
      <img [src]="resources.images.consultSymbol" />
      <a href="https://www.philips.com/IFU" target="_blank">www.philips.com/IFU</a>
      <img class="caution-symbol" [ngClass]="{'unreleased' : isUnreleasedDevice}" [src]="resources.images.cautionSymbol" />
      <span *ngIf="isUnreleasedDevice"  class="caution-text" >{{'EvaluationPurposes' | cpLabelTranslate | async}}</span>
    </div>
    <div>
      <div class="manufacturer-date">
        <img class="manufacturer-symbol" [src]="resources.images.manufacturerDateSymbol" />
        <span>{{buildDate}}</span>
      </div>
      <div class="udi-hri-container" [ngClass]="{'unreleased' : isUnreleasedDevice}">
        <span>(01)00884838107144</span>
        <span>(11){{buildDateUDI}}(10){{commercialVersion}}</span>
      </div>
    </div>
  </div>
</div>
